export default {
  meta: {
    title: '标签库',
  },
};
